import { Table } from 'antd';
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, DashboardOutlined,BranchesOutlined } from "@ant-design/icons";

import React, { useState, useEffect } from 'react';
import { BarChartOutlined} from "@ant-design/icons";
import {get} from "../Libraries/Ajax/HttpService";
import back from '../assets/images/back.svg';
import { useDistrict } from "../utils/DistrictContext";
function Stats() {
    // let history = useHistory();
    const navigate = useNavigate();
    const [data, setdata] = useState([]);
    const [datas, setdatas] = useState([]);
    const [datass, setdatass] = useState([]);
    const [loading, setloading] = useState(true);
    const [dataone, setdataone] = useState();
    const [datatwo, setdatatwo] = useState();
    const [inactive,setInactive] = useState();
    const [operational,setOperational] = useState();
    const [nonoperational,setNonoperational] = useState();
    const [datathree, setdatathree] = useState();
    const [forceUpdateFlag, setForceUpdateFlag] = useState(false);
    const { selectedDistrict } = useDistrict();
    const columns = [

        {
            title: 'Category',
            dataIndex: 'name',
            key: 'name',
            

        },
        {
            title: 'Operational',
            dataIndex: 'op',
            key: 'op',
            align: 'center',
            children:
            [
                {
                    title: '',
                    dataIndex: 'override',
                    align: 'center',
                    key: 'override'
                },
            ],
        },

        {
            title: 'Non-Operational',
            dataIndex: 'op',
            key: 'op',
            align: 'center',
            children:
            [
                {
                    title: '',
                    dataIndex: 'overrides',
                    align: 'center',
                    key: 'overrides'
                },
            ],
        },
        
      


        // {
        //     title: 'Actions',
        //     dataIndex: 'action',
        //     key: 'id',
        //     onCell: (record) => {
        //         return {
        //             onClick: (ev) => {
        //                 onEditClick(record.id,record.override)
        //             },
        //         };
        //     },
        //     render: (_, record) => (
        //         <EditOutlined style={{ fontSize: '30px', color: '#08c' }}
        //         // onClick={onEditClick(record.id,record.override)}
        //         />

        //     )

        // },
    ];

    const onselectClick = () => {
        navigate('/stats');

    }
    const onselectClicks = () => {
        navigate('/devices');

    }
    const onselectClickss = () => {
        navigate('/schematics');

    }
    const onRedirection = (event) => {

        // history.push('/dashboard');
        // window.history.back();
        navigate(-1);
    }
    const mergeArrays = (arr1, arr2, key) => {
        // Create a map using the common key from arr1
        const map = new Map(arr1.map(item => [item[key], item]));
    
        // Merge the arrays based on the common key
        const mergedArray = arr2.map(item => ({
          ...item,
          ...map.get(item[key]), // Merge properties from arr1 into arr2
        }));
    
        return mergedArray;
      };
    
     
    
      useEffect(() => {
        // Your logic that should trigger a re-render goes here
        // When you want to force a re-render, set the flag to the opposite of its current value
       
      }, [datass,selectedDistrict]);
    
    
    useEffect(() => {
        getData()
    }
        , [selectedDistrict])
   

    const getData = async () => {

        setloading(true);
         get('apis/meter_stat_operational/count').then(
         (res) => { 
                setloading(false);
                    
                const hay = res.data.data.operational_category_count.map(row => ({ name: row.name, override: row.count }))
                console.log("--------gg-------->>",hay)
               
                    setdata(res.data.data.operational_category_count.map(row => ({ name: row.name, override: row.count })));
                    setdatass(res.data.data.non_operational_category_count.map(row => ({ name: row.name, overrides: row.count })));
                    const mergedArray = mergeArrays(res.data.data.operational_category_count.map(row => ({ name: row.name, override: row.count })),res.data.data.non_operational_category_count.map(row => ({ name: row.name, overrides: row.count })) , 'name');
                    // setdatass(mergedArray);
                    // console.log("-------------------daat--ddf------------>>",res.data.data.non_operational_category_count)                    
                   
                      setdatass(mergedArray);
                  
               
                // console.log(mergedArray);
                setdataone(res.data.data.count[0].count);
                setdatatwo(res.data.data.count[2].count);
                setdatathree(res.data.data.count[1].count);
                setInactive(res.data.data.count[3].count);
                setOperational(res.data.data.count[4].count);
                setNonoperational(res.data.data.count[5].count);
                // console.log("hhhh",mergedArray);
                // console.log("data",data);
                console.log("datas",datass);
                setForceUpdateFlag(true);
            
            });
    //         get('apis/meter_stat/count').then(
    //         (res) => { 
    //     setloading(false);
    //     setdata(res.data.data.category_count.map(row => ({ name: row.name, override: row.count })));
    //     setdataone(res.data.data.count[0].count);
    //     setdatatwo(res.data.data.count[2].count);
    //     setdatathree(res.data.data.count[1].count);
    //     setInactive(res.data.data.count[3].count);

    //     console.log(data);
    
    // });
}

    return (
        <>
        {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"} </title></head> */}
            <Header />
            <Main>
                <div>
                    <div className="d-flex align-items-center justify-content-between">
                        {/* <div className="d-flex fs-30 gap-3">
                            <ArrowLeftOutlined onClick={onRedirection} />
                            <h3 className="my-4">Devices</h3>
                        </div> */}
                        <div className="d-flex align-items-center ">
                            <img src={back} alt="" style={{width:'10px', cursor: 'pointer'}} onClick={onRedirection}  />
                            {/* <h3 className="mb-0 ms-3">Devices</h3> */}
                            <div className='d-flex align-items-center'>
                                <div className="new-box-padding   align-self-center c-pointer "
                                style={{
                                    borderBottom: '2px solid #ccc',
                                }}
                                
                                onClick={onselectClickss}>
                                    {/* <BranchesOutlined className="me-1" /> */}
                                    Digital Twin </div>
                                <div className="" style={{width: '2px', height: '25px', background: '#ccc' }}></div>
                                <div className="new-box-padding  text-blue  align-self-center c-pointer " 
                                style={{    borderBottom: '2px solid #1998f0',
                                borderRadius: '0'}} 
                                onClick={onselectClick}>
                                    
                                    {/* <BarChartOutlined className="me-1" /> */}
                                    
                                    Stats </div>
                                <div className="" style={{width: '2px', height: '25px', background: '#ccc' }}></div>
                                <div className="new-box-padding   align-self-center c-pointer "  style={{
                                                                    borderBottom: '2px solid #ccc',
                                                                }}
                                onClick={onselectClicks}>
                                {/* <DashboardOutlined title="Meter" className="me-1" /> */}
                                
                                 Meters</div>

                            </div>
                        </div>
                        {/* <div className="fs-20 fw-bold d-flex gap-2"> */}
                        {/* <div className=" d-flex gap-3" style={{fontSize:'16px'}}>
                        <div className="px-3 py-1 bg-white border rounded align-self-center c-pointer ph-meter-stats d-flex" onClick={onselectClickss}>
                                <BranchesOutlined className="me-1"/>Schematic
                            </div>  
                            <div className="px-3 py-1 bg-white ph-meter-stats border text-blue border-info rounded align-self-center c-pointer d-flex" onClick={onselectClick}>
                                <BarChartOutlined className="me-1"/>Stats
                            </div>  
                            <div className="px-3 py-1 bg-white border rounded align-self-center c-pointer ph-meter-stats d-flex" onClick={onselectClicks}>
                                <DashboardOutlined title="Meter" className="me-1"/> Meters
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="row row-cols-4 mt-2 g-3">
                    <div className="col-12 col-lg">
                        <div className="trend set-sec-trend">
                            <p className="text-grey">Accounts</p>
                            <span className="trend-span"> {dataone}</span>
                        </div>
                    </div>
                    <div className="col-12 col-lg">
                        <div className="trend set-sec-trend">
                            <p className="text-grey">Meters</p>
                            <span className="trend-span"> {datatwo} </span>
                        </div>
                    </div>
                    <div className="col-12 col-lg">
                        <div className="trend set-sec-trend">
                            <p className="text-grey">Unique Meter IDs</p>
                            <span className="trend-span">{datathree}</span>
                        </div>
                    </div>
                    <div className="col-12 col-lg">
                        <div className="trend set-sec-trend">
                            <p className="text-grey">Operational  Meters</p>
                            <span className="trend-span">{operational}</span>
                        </div>
                    </div>
                    <div className="col-12 col-lg">
                        <div className="trend set-sec-trend">
                            <p className="text-grey">Non-Operational  Meters</p>
                            <span className="trend-span">{nonoperational}</span>
                        </div>
                    </div>
                </div><br />
                <div>




                    <Table columns={columns} className="styleRemove account-table" dataSource={datass} size="middle" pagination={false} 
                    // onRow={(record) => {
                    //     return {
                    //         onClick: event => { onEditClick(record.id, record.override) }
                    //     }
                    // }} 
                    />


                </div>
            </Main>

        </>
    );

}


export default Stats;